import React, { Component } from "react";
import AudioStyledComponent from "./AudioStyledComponent";
import { getServerEndpoint } from "utils/serverEndpoint";
import { fetchStaticResource } from "../../../../utils/utils";
class AudioArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      audioPaths: {}, // Stores fetched audio paths
    };
  }

  async componentDidMount() {
    if (this.props.audio) {
      const audioPaths = {};
      for (const voice of this.props.audio) {
        if (voice.voiceName) {
          const path = getServerEndpoint() + "audio/" + voice.voiceName;
          try {
            audioPaths[voice.voiceName] = await fetchStaticResource(path);
          } catch (error) {
            console.error("Error fetching audio:", error);
            audioPaths[voice.voiceName] = null; // Set to null if fetch fails
          }
        }
      }
      this.setState({ audioPaths });
    }
  }

  render() {
    const { audioPaths } = this.state;

    const audioComps = this.props.audio
      ? this.props.audio.map((voice) => {
          if (voice.voiceName && audioPaths[voice.voiceName]) {
            return (
              <AudioStyledComponent
                key={voice.voiceName}
                voice={voice.voiceName}
                paths={audioPaths[voice.voiceName]} // Use fetched audio path
              />
            );
          }
          return null; // Avoid rendering invalid audio components
        })
      : null;

    return <div style={{ display: "inline-block" }}>{audioComps}</div>;
  }
}


export default AudioArea;



// WEBPACK FOOTER //
// ./src/components/IssuesReports/IssueDetail/AudioComponent/AudioArea.jsx